import type React from 'react';
import {newId} from '../../../domain/planText';
import type {PlanProps} from '../strategyProps';
import {EditableList} from '../EditableList';
import {PlanSection} from '../PlanSection';
import {HelpTitle} from '../SectionLinks';

const RISKS_HELP = 'Drafted from the category’s risk flags: the badges next to the category name at the top '
    + '(single-source exposure, supplier concentration, fast spend growth, tail spend), up to two, each with a '
    + 'mitigation; topped up to two with general risks (prices above the market index, contracts expiring early). The '
    + 'flag thresholds are in the settings. Add, edit and remove risks here.';

/** Key risk areas, each with a mitigation. Add / Remove with Undo. */
export const RisksSection: React.FC<PlanProps> = ({plan, actions}) => {
    const {risks} = plan.content;
    return (
        <PlanSection title={<HelpTitle title="Key risk areas" help={RISKS_HELP} links={[]}/>} edited={plan.edited.includes('risks')}>
            <EditableList
                    items={risks} readOnly={!plan.canEdit} addLabel="Add risk" emptyText="No risks listed."
                    fields={[{key: 'risk', placeholder: 'Risk'}, {key: 'mitigation', placeholder: 'Mitigation', secondary: true}]}
                    create={() => ({id: newId('r', risks), risk: 'New risk', mitigation: ''})}
                    onChange={(next, message) => void actions.save('risks', next, `Risk ${message.toLowerCase()}`)}
            />
        </PlanSection>
    );
};
